export enum StepState {
	TODO = "TO DO",
	CURRENT = "CURRENT",
	DONE = "DONE",
}

export enum BooleanValues {
	TRUE = "true",
	FALSE = "false",
	ON = "on",
	OFF = "off",
}

export enum StatoAttivitaEnum {
	Attiva = "A",
	Cessata = "C",
	InProcedure = "D",
	Fallita = "F",
	Inattiva = "I",
	InScioglimentoLiquidazione = "L",
	InProceduraConsorsiale = "N",
	Iscrizione = "P",
	Registrata = "R",
	Sospesa = "S",
	Cancellata = "T",
}

export enum TipoTitolare {
	TITOLARE_UNICO = "TitolareUnico",
	TITOLARE = "Titolare",
	NON_TITOLARE = "NonTitolare",
	NON_TITOLARE_PF = "NonTitolarePF",
	VOID = "",
}

export enum TipoSoggetto {
	LR = "RappresentanteLegale",
	TE = "Titolare",
}

export enum TipoInserimento {
	MANUALE = "0",
}

export enum ServiceStatus {
	SUCCESS = 200,
	ERROR = 500,
	UNAUTHORIZED = 401,
	FORBIDDEN = 403,
}

export const STATI_ATTIVITA = {
	A: "Attiva",
	C: "Cessata",
	D: "In procedure",
	F: "Fallita",
	I: "Inattiva",
	L: "In scioglimento/liquidazione",
	N: "In procedura consorsiale",
	P: "Iscrizione",
	R: "Registrata",
	S: "Sospesa",
	T: "Cancellata",
};

export const StatiCarichiPendenti = [
	{ key: "", value: "" },
	{ key: "In corso", value: "In corso" },
	{ key: "Concluso", value: "Concluso" },
];

export enum IdTipoDocumenti {
	ATTO_COSTITUTIVO = "ASS_ATC",
	ATTRIBUZIONE_PARTITA_IVA = "ASS_API",
	VERBALE_RAPP_LEGALE = "ASS_VRL",
	TULPS_GIOCO = "SCO_TGI",
	LICENZA_AAMS = "SCO_LAA",
	DELEGA_CASA_MADRE = "SCO_DCM",
	PATENTE_FRONT = "DOC_PAT_FRONT",
	PATENTE_BACK = "DOC_PAT_BACK",
	CARTA_ID_FRONT = "DOC_IDE_FRONT",
	CARTA_ID_BACK = "DOC_IDE_BACK",
	PASSAPORTO_FRONT = "DOC_PAS_FRONT",
	PASSAPORTO_BACK = "DOC_PAS_BACK",
	TESSERA_SANITARIA = "TES_SAN",
	INT_ESTRATTO_CONTO = "INT_ESTRATTO_CONTO",
	CONTRATTO = "CONTRATTO",
	CONTRATTO_UTENZA_LOCAZIONE = "CONTRATTO_UTENZA_LOCAZIONE",
	LICENZA_AUTORIZZATIVA = "LIC_AUT",
}

export enum IdTipoDocumentiEstesi {
	ATTO_COSTITUTIVO = "il documento ATTO COSTITUTIVO",
	ATTRIBUZIONE_PARTITA_IVA = "il documento ATTRIBUZIONE PARTITA IVA",
	VERBALE_RAPP_LEGALE = "il documento VERBALE RAPPRESENTANTE LEGALE",
	TULPS_GIOCO = "il documento TULPS GIOCO",
	LICENZA_AAMS = "il documento LICENZA AAMS",
	DELEGA_CASA_MADRE = "il documento DELEGA CASA MADRE",
	PATENTE_FRONT = "il documento PATENTE FRONTE",
	PATENTE_BACK = "il documento PATENTE RETRO",
	CARTA_ID_FRONT = "il documento CARTA D'IDENTITA' FRONTE",
	CARTA_ID_BACK = "il documento CARTA D'IDENTITA' RETRO",
	PASSAPORTO_FRONT = "il documento PASSAPORTO FRONTE",
	PASSAPORTO_BACK = "il documento PASSAPORTO RETRO",
	TESSERA_SANITARIA = "il documento TESSERA SANITARIA FRONTE",
	INT_ESTRATTO_CONTO = "il documento INTESTAZIONE ESTRATTO CONTO",
	CONTRATTO = "il documento CONTRATTO",
	CONTRATTO_UTENZA_LOCAZIONE = "il documento CONTRATTO UTENZA LOCAZIONE",
	LICENZA_AUTORIZZATIVA = "il documento LICENZA AUTORIZZATIVA",
}

export enum IdTipoDocumentiUpload {
	ATTO_COSTITUTIVO = "ASS_ATC",
	ATTRIBUZIONE_PARTITA_IVA = "ASS_API",
	VERBALE_RAPP_LEGALE = "ASS_VRL",
	TULPS_GIOCO = "SCO_TGI",
	LICENZA_AUTORIZZATIVA = "LIC_AUT",
	INT_ESTRATTO_CONTO = "INT_ESTRATTO_CONTO",
	CONTRATTO_UTENZA_LOCAZIONE = "CONTRATTO_UTENZA_LOCAZIONE",
}

export enum TipoDocumenti {
	CARTA_IDENTITA = "DOC_IDE",
	PATENTE = "DOC_PAT",
	PASSAPORTO = "DOC_PAS",
}
